@if (!showDetailButton) {
  <button type="button" style="background:none;border:none;padding:0;font:inherit;color:inherit;cursor:pointer;" (click)="onClick($event)">{{ text }}</button>
} @else {
  <button class="button tiny" (click)="onClick($event)">{{text}}</button>
}

